import type { IconSvgObject } from './types';

const RailSymbolIcon: IconSvgObject = [
  ["path", { d: "M4 9H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 4C10 4 15 7.68237 15 8.99996C15 10 12 12 12 12C12 12 9.00002 14 9.00003 15C9.00004 16.3176 14 20 14 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4 15H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default RailSymbolIcon;
